import React, { useEffect, useState } from "react";

import Icon from "@/public/core/components/Icon";
import { clearNotifications } from "@/slices/auth";
import { compose } from "redux";
import { connect } from "react-redux";
import iconClose from "@/images/ic_close.png";
import styled from "styled-components";
import theme from "@/styles/theme";
import { useNavigate } from "react-router-dom";
import withUserProp from "@/dashboard/shared/hocs/withUserProp";

const Banner = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 64px;
  background-color: ${theme.colors.red};
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;

  padding: 0 64px;

  color: ${theme.colors.white};
`;

const Reconnect = styled.span`
  text-decoration: underline;
  cursor: pointer;
`;

const CloseButtonContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
`;

const CloseButton = styled.div`
  cursor: pointer;
  padding: ${theme.spacing.unit * 1}px;
`;

export const Notifications = ({
  user,
  clearNotifications: _clearNotifications,
}) => {
  const navigate = useNavigate();

  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    // If we have a user, set the notifications and then remove them from the user
    if (user) {
      setNotifications(user.notifications);
    }
  }, [user, _clearNotifications]);

  const handleDismissClick = () => {
    setNotifications([]);

    _clearNotifications();
  };

  const handleReconnectClick = () => {
    navigate("/employers/sequence-campaigns");

    handleDismissClick();
  };

  if (notifications?.length > 0) {
    // For now, only support the errored inbox notification
    const erroredInboxNotification = notifications.find(
      (notification) =>
        notification.type === "errored-inbox-connection" ||
        notification.type === "unauthorized-inbox-connection" ||
        notification.type === "missing-inbox-connection"
    );

    if (erroredInboxNotification) {
      return (
        <Banner>
          <div>
            <span>
              Your email account has been disconnected and your sequences have
              been paused. Please&nbsp;
            </span>
            <Reconnect onClick={handleReconnectClick}>reconnect</Reconnect>
            <span>.</span>
          </div>
          <CloseButtonContainer>
            <CloseButton onClick={handleDismissClick}>
              <Icon src={iconClose} iconColor={theme.colors.white} />
            </CloseButton>
          </CloseButtonContainer>
        </Banner>
      );
    }
  }

  return null;
};

const enhance = compose(
  withUserProp,
  connect(null, {
    clearNotifications,
  })
);

export default enhance(Notifications);
